import React, { useEffect, useState } from 'react'
import DefaultLayout from '../components/DefaultLayout'
import { Row, Col, Form, Tabs, Input, Button, DatePicker, Select } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { postElectrical, editElectrical } from '../redux/actions/electricalActions'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;
const typeList = ["Machine related", "Lack of manpower", "Part shortage", "Downstream shortage of parts", "Overproduction", "Waiting for Cabinet", "Others"];

function PostElectrical({ match }) {
  const { electricalList } = useSelector(state => state.electricalReducer)
  const electrical = match.params?.id ? electricalList.map((x) => {
    return {
      ...x,
      potentialFailureModes: typeList.find(y => y.toLowerCase() == x.potentialFailureModes?.toLowerCase()) ? x.potentialFailureModes : "Others",
      others: typeList.find(y => y.toLowerCase() == x.potentialFailureModes?.toLowerCase()) ? "" : x.potentialFailureModes,
    }

  }).find(electrical => electrical._id == match.params.id) : null;

  const [activeTab, setActiveTab] = useState("0")
  const [isOthers, setIsOthers] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()

  function onFinalFormFinish(values) {
    const finalObj = { ...values, potentialFailureModes: values.potentialFailureModes.toLowerCase() == "others" ? values.others : values.potentialFailureModes };
    dispatch(electrical ? editElectrical({ ...finalObj, _id: electrical._id }) : postElectrical(finalObj));
  }

  const check = (value) => {
    setIsOthers(value.toLowerCase() === "others")
  }

  useEffect(() => {
    if (electrical) {
      setIsOthers(electrical.potentialFailureModes.toLowerCase() === "others")
    }
  }, [electricalList])

  const user = JSON.parse(localStorage.getItem('user'))

  useEffect(() => {
    if (user && !user.isAdmin) {
      const menu = user.menu.find(x => x.name.toLowerCase() == 'electrical');
      const rights = menu.rights ?? [];

      if (match.path.includes('edit') && !rights.some(x => x.toLowerCase() == 'edit')) {
        history.push('/');
      }

      if (match.path.includes('post') && !rights.some(x => x.toLowerCase() == 'write')) {
        history.push('/');
      }
    }
  }, [user])

  return (
    <div>
      <DefaultLayout>
        <Tabs defaultActiveKey='0' activeKey={activeTab}>
          <TabPane tab={`${electrical ? 'Edit' : 'Add'} Electrical`} key='0'>
            <Form
              onFinish={onFinalFormFinish}
              onReset={() => { history.push('/') }}
              initialValues={electrical ? { ...electrical, date: moment(new Date(electrical.date), 'ddd, MMMM Do YYYY') } : null}
              validateMessages={{ required: '${label} is required!' }}
            >
              {/* <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='workOrder' rules={[{ required: true }]} label='Work Order#' >
                    <Input type='text' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='model' rules={[{ required: true }]} label='Model' >
                    <Input type='text' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='run' rules={[{ required: true }]} label='Run' >
                    <Input type='text' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='runSize' rules={[{ required: true }]} label='Run Size' >
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row> */}
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='date' rules={[{ required: true }]} label='Date' initialValue={moment(new Date(), 'ddd, MMMM Do YYYY')}>
                    <DatePicker
                      format='ddd, MMMM Do YYYY'
                      defaultValue={moment(new Date(), 'ddd, MMMM Do YYYY')}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='totalStaff' rules={[{ required: true }]} label='Total Staff'>
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='shiftHours' rules={[{ required: true }]} label='Shift hours'>
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='adjustedHours' rules={[{ required: false }]} label='Adjusted hours'>
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='controlBox' rules={[{ required: true }]} label='Control Box'>
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='powerBox' rules={[{ required: true }]} label='Power Box'>
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='comment' rules={[{ required: false }]} label='Comment'>
                    <TextArea rows={4} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='quarantineTags' label='Quarantine Tags'>
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='problemDescription' label='Problem Description'>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='serialPlatesUsedStart' label='Serial Plates Used Start #'>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='serialPlatesUsedEnd' label='Serial Plates Used End #'>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='downtimeMins' label='Downtime(mins)'>
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='controller' label='Controller'>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='capacitorSubAssembly' label='Capacitor Sub Assembly'>
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='saleKits' label='Sale Kits'>
                    <Input type='number' />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='potentialFailureModes' label='Potential Failure Modes' rules={[{ required: true }]}>
                    <Select
                      onChange={check}
                    >
                      {typeList.map((x, i) => {
                        return (
                          <Option key={i} value={x}>{x}</Option>
                        )
                      })}
                    </Select>
                  </Form.Item>

                </Col>
              </Row>
              {isOthers && <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='others' label='Others'>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>}

              <Button htmlType='submit'>Submit</Button>
              <Button htmlType='reset' type="default" danger className="ml-2">Cancel</Button>
            </Form>
          </TabPane>

        </Tabs>
      </DefaultLayout>
    </div>
  )
}

export default PostElectrical
